/**
 * Displays the loading spinner by setting the display style of the
 * element with the ID "loadingOverlay" to "flex".
 */
export function showSpinner(spinner_id) {
    document.getElementById(spinner_id).style.display = "flex";
}

/**
 * Hides the loading spinner overlay by setting its display style to "none".
 */
export function hideSpinner(spinner_id) {
    document.getElementById(spinner_id).style.display = "none";
}
